export const specialLangs = ['arabic', 'english', 'kurdish'];

export const toUpperCaseSpecialLangs = (str) => {
  if (!str) return '';

  if (specialLangs.includes(str.toLowerCase())) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  return str;
};
